module.exports = __webpack_public_path__ + "static/media/demo-video.13186c15.mp4";